import { render, staticRenderFns } from "./todo-list-card.vue?vue&type=template&id=db51e432&scoped=true"
import script from "./todo-list-card.vue?vue&type=script&lang=js"
export * from "./todo-list-card.vue?vue&type=script&lang=js"
import style0 from "./todo-list-card.vue?vue&type=style&index=0&id=db51e432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db51e432",
  null
  
)

export default component.exports